import React from "react";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedinIn,
  faGithub,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

const Footer: React.FC = () => {
  const { t } = useTranslation('footer');
  const copyrightYear = 2025;

  return (
    <footer className="relative mt-4 overflow-hidden border-t border-primary-500/15 bg-[#0f051c] p-6 text-dark-300 shadow-lg">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary-500/40 to-transparent" />
      <div aria-hidden="true" className="pointer-events-none absolute -top-16 left-1/4 h-40 w-40 rounded-full bg-primary-500/10 blur-3xl animate-pulse" />
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-16 right-1/4 h-40 w-40 rounded-full bg-primary-500/10 blur-3xl animate-pulse" />
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-1 gap-8 text-center">


          {/* Upcoming Pages */}
          <div>
            <h3 className="text-lg font-bold text-purple-200 mb-4">{t('soonPagesTitle')}</h3>
            <ul className="space-y-2">
              <li><a href="/ads" className="group inline-flex items-center gap-2 text-dark-300 transition-all duration-300 hover:text-primary-400"><span>{t('adsSoon')}</span><span className="translate-x-0 opacity-0 group-hover:translate-x-1 group-hover:opacity-100 transition-all duration-300">→</span></a></li>
              <li><a href="/projects" className="group inline-flex items-center gap-2 text-dark-300 transition-all duration-300 hover:text-primary-400"><span>{t('projectsSoon')}</span><span className="translate-x-0 opacity-0 group-hover:translate-x-1 group-hover:opacity-100 transition-all duration-300">→</span></a></li>
            </ul>
          </div>

          {/* Copyright */}
          <div className="text-center">
            <p className="text-dark-400 mb-2">{t('madeWith')}</p>
            <p className="text-dark-500 text-sm font-display">
              {t('copyright', { year: copyrightYear })}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
